import { Guid } from "./CustomType"

export enum FactoryTypeEnum {
  LiteTestReport = "Lite Test Report",
  TestReport = "Test Report",
  RoutineTestCertificate = "Routine Test Certificate",
}

export interface FactoryGet {
  id: Guid
  name: string
  type: keyof typeof FactoryTypeEnum
  isFree: boolean
  isEnabled: boolean
  maxDays: number
}

export interface FactoryPost {
  name: string
  type: keyof typeof FactoryTypeEnum
  isFree: boolean
  isEnabled: boolean
  maxDays: number
}

export interface FactoryPut {
  name: string
  type: keyof typeof FactoryTypeEnum
  isFree: boolean
  isEnabled: boolean
  maxDays: number
}
